<template>
  <div id="contenedor-estatus-pago">
    <template
      v-if="estatus.texto === 'No pagada'">
      --
    </template>
    <template
      v-else>
      <v-chip
        :color="estatus.color"
        :small="small">
        {{ estatus.texto }}
        <span
          class="ml-1">
          {{ estatus.fecha }}
        </span>
      </v-chip>
    </template>
  </div>
</template>

<script>
export default {
  name: 'EstatusDePago',
  props: {
    solicitud: {
      type: Object,
    },
    small: {
      type: Boolean,
    },
  },
  data() {
    return {};
  },
  computed: {
    estatus() {
      // Sin estatus
      if (!this.solicitud) {
        return {
          texto: 'No pagada',
          color: 'grey',
        };
      }

      // Si ya tiene un pago mosrar que ya esta pagado
      // if (this.solicitud.pagosDetalles.length > 0) {
      //   // Extraer el ultimo pago
      //   const ultimoPago = this.solicitud.pagosDetalles[this.solicitud.pagosDetalles.length - 1];
      //   return {
      //     texto: 'Pagado',
      //     color: 'success',
      //     fecha: new Date(ultimoPago.createdAt).toLocaleDateString(),
      //   };
      // }

      // Si no tiene pago mostrar solicitado
      return {
        // texto: 'Solicitado',
        // color: 'warning',
        // fecha: new Date(this.solicitud.createdAt).toLocaleDateString(),
        texto: 'Pagado',
        color: 'success',
        fecha: this.$moment(this.solicitud.fecha).format('DD/MM/YYYY'),

      };
    },
  },
};
</script>

<style lang="scss">

</style>
